<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <div class="ttshop_userights">
            <div class="ttshop_myorder clearfloat">
              <ul class="clearfloat">
                <li @click="orderTab(-1)" :class="{ active: currTab == -1 }">
                  全部订单
                </li>
                <li @click="orderTab(0)" :class="{ active: currTab == 0 }">
                  待付款
                </li>
                <li @click="orderTab(1)" :class="{ active: currTab == 1 }">
                  待发货
                </li>
                <li @click="orderTab(2)" :class="{ active: currTab == 2 }">
                  待收货
                </li>
                <li @click="orderTab(3)" :class="{ active: currTab == 3 }">
                  已完成
                </li>
                <li @click="orderTab(4)" :class="{ active: currTab == 4 }">
                  退款/售后
                </li>
              </ul>
              <div class="ttshop_myorderseach" style="display: none">
                <input type="text" placeholder="请输入您的订单号" />
                <button>搜索订单</button>
              </div>
            </div>
            <!-- 暂无订单展示 -->
            <div v-show="list.length == 0">
              <div class="ttshop_myorderzw" v-show="finish">
                <img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="" />
                <p>暂无订单</p>
              </div>
            </div>

            <!-- 订单列表 -->
            <div class="ttshop_myorderlist" v-show="list.length > 0">
              <div class="ttshop_myordertitle clearfloat">
                <div style="float: left; width: 48%" class="clearfloat">
                  <div class="ttshop_myordertext">
                    <div class="ttshop_myordertexter clearfloat">
                      <p>商品信息</p>
                      <!-- <el-dropdown>
                      <p>商品信息</p>
                      <i><img class="img-default" src="../../assets/images/ttshop_orderxl.png" alt=""></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>昨天</el-dropdown-item>
                        <el-dropdown-item>近一周</el-dropdown-item>
                        <el-dropdown-item>近一个月</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown> -->
                    </div>
                  </div>
                  <div class="ttshop_myorderdj">
                    <p>单价</p>
                  </div>
                  <div class="ttshop_myorderdj">
                    <p>数量</p>
                  </div>
                </div>

                <!-- <div class="ttshop_myorderzt">
                  <div class="ttshop_myorderzts d-flex justify-content-center clearfloat">
                    <p>全部状态</p>
                    <el-dropdown>
                      <p>全部状态</p>
                      <i><img class="img-default" src="../../assets/images/ttshop_orderxl.png" alt=""></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>已发货</el-dropdown-item>
                        <el-dropdown-item>待发货</el-dropdown-item>
                        <el-dropdown-item>已付款</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div> -->
                <div class="ttshop_myorderdjs">
                  <p>收货人</p>
                </div>
                <div class="ttshop_myorderzfje">
                  <p>支付总金额</p>
                </div>
                <div class="ttshop_myordercz">
                  <p>操作</p>
                </div>
              </div>
              <div class="ttshop_myordercon" v-for="(item, index) in list" :key="index">
                <div class="ttshop_myorderconed clearfloat">
                  <div class="ttshop_myordercontitle clearfloat">
                    <p>{{ item.addtime }}</p>
                    <p>
                      订单号：<span>{{ item.order_no }}</span>
                    </p>
                    <p>
                      卖家：<strong>{{ item.mch.name }}</strong>
                    </p>
                    <div class="ttshop_myordercontitle_right">
                      <template v-if="currTab == -1">
                        <p class="ttshop_over" v-if="
                          item.is_pay == 1 &&
                          item.is_send == 0 &&
                          item.apply_delete == 1 &&
                          item.is_revoke == 1
                        ">
                          退款成功
                        </p>
                        <p class="ttshop_over" v-else-if="item.is_revoke == 1">
                          已取消
                        </p>
                        <template v-else-if="item.is_pay == 0">
                          <template v-if="item.pay_type == 2">
                            <p class="ttshop_over" v-if="item.is_send == 0 && item.is_revoke == 0">
                              待发货
                            </p>
                            <p class="ttshop_over" v-if="item.is_send == 1 && item.is_confirm == 0">
                              待收货
                            </p>
                            <p class="ttshop_over" v-if="
                              item.is_comment == 0 && item.is_confirm == 1
                            ">
                              待评价
                            </p>
                            <p class="ttshop_over" v-else-if="item.is_confirm == 1">
                              已收货
                            </p>
                          </template>
                          <p class="ttshop_over" v-else>待付款</p>
                        </template>
                        <p class="ttshop_over" v-if="
                          item.is_send == 0 &&
                          item.is_pay == 1 &&
                          item.is_revoke == 0
                        ">
                          待发货
                        </p>
                        <p class="ttshop_over" v-if="item.is_send == 1 && item.is_confirm == 0">
                          待收货
                        </p>
                        <p class="ttshop_over" v-if="item.is_comment == 0 && item.is_confirm == 1">
                          待评价
                        </p>
                        <p class="ttshop_over" v-else-if="item.is_confirm == 1">
                          已收货
                        </p>
                      </template>
                      <template v-if="currTab == 4">
                        <p class="ttshop_over" v-if="item.refund_type == 1">
                          退货退款：￥{{ item.refund_price }}
                        </p>
                        <p class="ttshop_over" v-if="item.refund_type == 2">
                          换货
                        </p>
                      </template>
                    </div>
                  </div>
                  <div class="clearfloat d-flex orderlist">
                    <div class="listitem">
                      <div class="ttshop_myorderconlist clearfloat" v-for="(items, idx) in item.goods_list" :key="idx"
                        @click.stop="goods_detail(items.goods_id)">
                        <div class="ttshop_myorderconleft clearfloat">
                          <div class="ttshop_orderimg">
                            <img class="img-default" :src="items.goods_pic" alt="" />
                          </div>
                          <div class="ttshop_ordertext">
                            <h5>{{ items.goods_name }}</h5>
                            <span v-for="(attr, ids) in items.attr_list" :key="ids">{{ attr.attr_group_name
                            }}:<strong>{{
                              attr.attr_name
                              }}</strong></span>
                            <!-- <span>尺码：<strong>170/M</strong></span> -->
                            <!-- <div>123</div> -->
                          </div>
                        </div>
                        <div class="ttshop_myorderdj">
                          <p>
                            ￥<span>{{ items.price }}</span>
                          </p>
                        </div>
                        <div class="ttshop_myorderdj ttshop_myorderdjer">
                          <p>
                            <span>{{ items.num }}</span>
                          </p>
                        </div>
                      </div>

                      <!-- <div class="ttshop_caozuo" style="display:none">
                        <p class="ttshop_ljzf" v-show="item.is_pay == 0 && item.pay_type != 2 && item.is_revoke == 0" @click="payOrder(item.order_id,item.total_price)">立即支付</p>
                        <p class="ttshop_ljzf" v-show="item.is_pay && item.is_send==0">退款</p>
                        <p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 1 && item.is_comment == 0">评价</p>
                        <p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 0">确认收货</p>
                        && store.store.is_comment == 1 是否开启评价
                        <p class="ttshop_cztext">修改订单</p>
                        <p class="ttshop_cztext" v-show="!item.is_pay && item.is_revoke == 0 && item.pay_type != 2" @click="orderRevoke(item.order_id)">取消订单</p>
                        <p class="ttshop_cztext" @click="goOrderxq(item)">订单详情</p>
                      </div> -->
                    </div>
                    <div class="ttshop_shr">
                      <p>{{ item.consignee }}</p>
                    </div>
                    <div class="ttshop_zfzje">
                      <p>
                        ￥<span>{{ item.pay_price }}</span>
                      </p>
                      <!-- <strong>发票信息</strong> -->
                    </div>
                    <div class="
                        ttshop_caozuos
                        d-flex
                        align-items-center
                        justify-content-center
                      ">
                      <div v-if="currTab == 4">
                        <!-- <view wx:if="{{item.refund_type==1}}">
                          <block wx:if="{{item.refund_status==0}}">
                            <text wx:if="{{item.is_agree==0}}">等待审核中</text>
                            <text wx:else>
                              <block wx:if="{{item.is_user_send==0}}">已同意退货，请及时发货</block>
                              <block wx:else>已发货，待平台确认</block>
                            </text>
                          </block>
                          <text wx:if="{{item.refund_status==1}}" style="color: #36ba75">已同意退货并已退款</text>
                          <text wx:if="{{item.refund_status==3}}" style="color: #ff4544">已拒绝退货</text>
                        </view>
                        <view wx:if="{{item.refund_type==2}}">
                          <block wx:if="{{item.refund_status==0}}">
                            <text wx:if="{{item.is_agree==0}}">等待审核中</text>
                            <text wx:else>
                              <block wx:if="{{item.is_user_send==0}}">已同意换货，请及时发货</block>
                              <block wx:else>已发货，待平台确认</block>
                            </text>
                          </block>
                          <text wx:if="{{item.refund_status==1}}" style="color: #36ba75">已同意换货</text>
                          <text wx:if="{{item.refund_status==2}}" style="color: #36ba75">卖家已发货</text>
                          <text wx:if="{{item.refund_status==3}}" style="color: #ff4544">已拒绝换货</text>
                        </view>
                        <view data-order-refund-id="{{item.order_refund_id}}" wx:if="{{item.refund_status==0 && item.is_agree==0}}" bindtap="withdraw" class="ctrlBtn">撤回申请</view> -->
                        <p class="ttshop_cztext" @click="goOrderxq(item)">
                          订单详情
                        </p>
                        <p class="ttshop_ljzf" v-if="item.refund_status == 0 && item.is_agree == 0"
                          @click="withdraw(item.order_refund_id)">
                          撤回申请
                        </p>
                        <template v-if="item.refund_type == 1">
                          <template v-if="item.refund_status == 0">
                            <p class="ttshop_cztexts" v-if="item.is_agree == 0">
                              等待审核中
                            </p>
                            <template v-else>
                              <p class="ttshop_cztexts" v-if="item.is_user_send == 0">
                                已同意退货，请及时发货
                              </p>
                              <p class="ttshop_cztexts" v-else>
                                已发货，待平台确认
                              </p>
                            </template>
                          </template>
                          <p class="ttshop_cztexts" v-if="item.refund_status == 1">
                            已同意退货并已退款
                          </p>
                          <p class="ttshop_cztexts" v-if="item.refund_status == 3">
                            已拒绝退货
                          </p>
                        </template>
                        <template v-if="item.refund_type == 2">
                          <template v-if="item.refund_status == 0">
                            <p class="ttshop_cztexts" v-if="item.is_agree == 0">
                              等待审核中
                            </p>
                            <template v-else>
                              <p class="ttshop_cztexts" v-if="item.is_user_send == 0">
                                已同意退货，请及时发货
                              </p>
                              <p class="ttshop_cztexts" v-else>
                                已发货，待平台确认
                              </p>
                            </template>
                          </template>
                          <p class="ttshop_cztexts" v-if="item.refund_status == 1">
                            已同意换货
                          </p>
                          <p class="ttshop_cztexts" v-if="item.refund_status == 2">
                            卖家已发货
                          </p>
                          <p class="ttshop_cztexts" v-if="item.refund_status == 3">
                            已拒绝退货
                          </p>
                        </template>
                      </div>
                      <div v-else>
                        <template v-if="item.is_pay == 0">
                          <template v-if="item.pay_type == 6">
                            <template v-if="!item.bank_receipt && item.is_revoke == 0">
                              <el-upload :on-change="
                                (file, fileList) => {
                                  handleChange(file, fileList, item.order_id);
                                }
                              " :show-file-list="false" action="/api/default/upload-image" accept="image/*"
                                :limit="1" :http-request="UploadImage" :multiple="false" :auto-upload="false"
                                ref="receipt_upload">
                                <p class="ttshop_ljzf">上传回执单</p>
                              </el-upload>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="
                              item.type == 8 &&
                              item.apply_delete != 1 &&
                              item.is_revoke == 0 &&
                              item.is_status == 0
                            ">
                              <div v-if="item.pre_data.ys_pay_status == 0">
                                <template v-if="item.pre_data.deposit_end">
                                  <div class="ttshop_ljzf" @click="pay_advance(index, item.order_id)">
                                    支付定金
                                  </div>
                                </template>
                              </div>
                              <div class="" v-else-if="item.pre_data.ys_pay_status == 1">
                                <template v-if="item.pre_data.final_end">
                                  <div class="ttshop_ljzf" @click="pay_advance(index, item.order_id)">
                                    支付尾款
                                  </div>
                                </template>
                                <template v-else>
                                  <span style="color: #ff0e25">{{
                                  item.pre_data.final_state
                                  }}</span>
                                </template>
                              </div>
                            </template>
                            <template v-else>
                              <p class="ttshop_ljzf" v-show="
                                item.is_pay == 0 &&
                                item.pay_type != 2 &&
                                item.is_revoke == 0 &&
                                item.apply_delete != 1
                              " @click="openPayType(index)">
                                立即支付
                              </p>
                            </template>
                          </template>
                        </template>
                        <template v-if="item.pay_type == 6 && item.bank_receipt">
                          <div class="monad_bill">
                            <template v-if="
                              item.is_pay == 0 &&
                              item.is_revoke == 0 &&
                              item.is_status == 0
                            ">
                              <el-upload :on-change="
                                (file, fileList) => {
                                  handleChange(file, fileList, item.order_id);
                                }
                              " :show-file-list="false" action="/api/default/upload-image" accept="image/*"
                                :multiple="false" :auto-upload="false" ref="receipt_upload">
                                <p class="ttshop_ljzf monad_chong">重新上传</p>
                              </el-upload>
                            </template>

                            <p class="ttshop_ljzf" @click="look_receipt(index)">
                              查看回执单
                            </p>
                          </div>
                        </template>
                        <!-- <p class="ttshop_ljzf" v-show="item.is_pay && item.is_send==0 &&item.apply_delete!=1" @click="orderRevoke(item.order_id)">退款</p> -->
                        <template v-if="
                          item.is_pay &&
                          item.is_send == 0 &&
                          item.apply_delete != 1
                        ">
                          <template v-if="item.type == 8">
                            <template v-if="item.pre_data.pre_info.is_refund != 0">
                              <p class="ttshop_ljzf" @click="turn_order(item)">
                                退款
                              </p>
                            </template>
                          </template>
                          <template v-else>
                            <p class="ttshop_ljzf" @click="turn_order(item)">
                              退款
                            </p>
                          </template>
                        </template>
                        <!-- <p
                          class="ttshop_ljzf"
                          v-show="
                            item.is_pay &&
                            item.is_send == 0 &&
                            item.apply_delete != 1
                          "
                          @click="turn_order(item)"
                        >
                          退款
                        </p> -->
                        <p class="ttshop_ljzf" v-show="
                          item.is_send == 1 &&
                          item.is_confirm == 1 &&
                          item.is_comment == 0
                        " @click="goEvaluate(item.order_id)">
                          评价
                        </p>
                        <p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 0"
                          @click="confirm(item.order_id)">
                          确认收货
                        </p>
                        <div class="ttshop_cztexts" v-show="
                          item.is_send == 0 &&
                          item.apply_delete == 1 &&
                          item.is_revoke == 0
                        ">
                          退款申请中
                        </div>
                        <p class="ttshop_cztexts" v-show="
                          item.is_send == 0 &&
                          item.apply_delete == 1 &&
                          item.is_revoke == 1
                        ">
                          退款成功
                        </p>
                        <!-- && store.store.is_comment == 1 是否开启评价 -->
                        <!-- <p class="ttshop_cztext">修改订单</p> -->
                        <template v-if="!item.is_pay && item.is_revoke == 0">
                          <template v-if="item.type == 8">
                            <template v-if="item.pre_data.pre_info.is_refund != 0">
                              <template v-if="
                                item.pre_data.ys_pay_status == 1 &&
                                item.pre_data.pre_info.is_refund == 1
                              ">
                                <div class="ttshop_cztext" @click="orderRevoke(item.order_id, index)">
                                  退定金
                                </div>
                              </template>
                              <template v-else>
                                <template v-if="
                                  item.pre_data.pre_info.is_refund == 2 &&
                                  item.pre_data.ys_pay_status == 2
                                ">
                                  <div class="ttshop_cztext" @click="orderRevoke(item.order_id, index)">
                                    退尾款
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="ttshop_cztext" @click="orderRevoke(item.order_id, index)">
                                    取消
                                  </div>
                                </template>
                              </template>
                            </template>
                            <template v-else>
                              <template>
                                <div class="ttshop_cztext" @click="orderRevoke(item.order_id, index)">
                                  取消
                                </div>
                              </template>
                            </template>
                          </template>
                          <template v-else>
                            <p class="ttshop_cztext" @click="orderRevoke(item.order_id, index)">
                              取消订单
                            </p>
                          </template>
                        </template>
                        <!-- <p
                          class="ttshop_cztext"
                          v-show="
                            !item.is_pay &&
                            item.is_revoke == 0 &&
                            item.pay_type != 2
                          "
                          @click="orderRevoke(item.order_id)"
                        >
                          取消订单
                        </p> -->
                        <!-- <template v-if="item.is_pay == 1&&item.is_send==1">
                          <p
                            class="ttshop_ljzf"
                            v-if="!item.refund"
                            @click="goBarter(item)"
                          >
                            申请售后
                          </p>
                          <p class="ttshop_cztexts" v-else>已申请售后</p>
                        </template> -->
                        <p class="ttshop_cztext" @click="goOrderxq(item)">
                          订单详情
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.pre_data && false" class="clearfloat d-flex orderlist">
                    <div class="listitem">
                      <div class="ttshop_myorderconlist clearfloat">
                        <div class="ttshop_myorderconleft clearfloat"></div>
                        <div class="ttshop_myorderdj"></div>
                        <div class="ttshop_myorderdj ttshop_myorderdjer"></div>
                        <div class="ttshop_shr">
                          <p>已开始</p>
                          <p>一借宿</p>
                        </div>
                        <div class="ttshop_zfzje">
                          <p>￥{{ item.pre_data.dep_price }}</p>
                          <p>￥{{ item.pre_data.fin_price }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="
                        ttshop_caozuos
                        d-flex
                        align-items-center
                        justify-content-center
                      ">
                      最后一个
                    </div>
                  </div>
                </div>
              </div>
              <div class="ttshop_myorderpage clearfloat" v-show="pageShow">
                <el-pagination class="ttshop_pages" @current-change="handleCurrentChange" :current-page.sync="page"
                  background layout="prev, pager, next" @prev-click="pages_perv" @next-click="page_next"
                  :page-count="page_count"></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ttshop_pay">
      <el-dialog title="" :visible.sync="shopVisible" :before-close="payContTypeChange">
        <div class="pay-title d-flex align-items-center justify-content-center">
          微信支付￥{{ payNum }}
        </div>
        <div class="pay-qrcode d-flex align-items-center justify-content-center">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
    </div>
    <Foot></Foot>
    <!-- 支付方式 -->
    <div class="ttshop_agreement" v-show="check_pay_type">
      <div class="ttshop_agreementbj" @click.stop="closePayType"></div>
      <div class="ttshop_agreementbox">
        <div class="ttshop_agreementitle clearfloat">
          <h5>支付方式</h5>
          <div class="close" @click.stop="closePayType"></div>
        </div>
        <div class="ttshop_agreementext">
          <div class="pay-item clearfloat" v-for="(payitem, payindex) in pay_type_list" :key="payindex"
            :data-index="payindex" v-show="
              payitem.payment == 0 ||
              payitem.payment == 1 ||
              payitem.payment == 4||payitem.payment == 7
            " @click="checkPayType" :class="{ active: payitem.payment == payment_type }">
            <div class="pay-img">
              <img class="img-default" :src="payitem.icon" alt />
            </div>
            <div class="pay-name">{{ payitem.name }}</div>
            <div class="pay-select" v-show="payitem.payment == payment_type">
              <img class="img-default" src="../../assets/images/brand.png" alt />
            </div>
          </div>
        </div>
        <div class="ttshop_agreementbut">
          <button @click="payOrder()">确定</button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <div v-if="receipt_detail" class="bill_monad">
        <img :src="receipt_detail.bank_receipt" alt="" />
      </div>
    </el-dialog>
    <!-- 预售的支付方式 -->
    <div class="ttshop_agreement" v-if="presell">
      <div class="ttshop_agreementbj" @click="pay_payment"></div>
      <div class="ttshop_agreementbox">
        <div class="ttshop_agreementitle clearfloat">
          <h5>支付方式</h5>
          <div class="close" @click="pay_payment"></div>
        </div>
        <div class="payment_head">
          <p class="payment_head_title">付款金额</p>
          <div class="payment_head_price">
            ￥
            <p v-if="advance_sale.pre_data">
              <template v-if="advance_sale.pre_data.ys_pay_status == 0">{{
              advance_sale.pre_data.dep_price
              }}</template>
              <template v-if="advance_sale.pre_data.ys_pay_status == 1">{{
              advance_sale.balance_cq_price
              }}</template>
            </p>
            <p v-else>{{ advance_sale.pay_price }}</p>
          </div>
        </div>
        <div class="payment_manner">
          <div class="manner_list clearfloat" v-for="(item, index) in ys_pay_type_list" :key="index" :data-index="index"
            @click="yscheckPayType" :class="{ active: item.payment == payment_ys_type }">
            <div class="pay-img">
              <img class="img-default" :src="item.icon" alt />
            </div>
            <div class="pay-name">{{ item.name }}</div>
            <div class="pay-select" v-show="item.payment == payment_ys_type">
              <img class="img-default" src="../../assets/images/brand.png" alt />
            </div>
          </div>
        </div>

        <template v-if="
          advance_sale.pre_data && advance_sale.pre_data.ys_pay_status == 1
        ">
          <div class="choice_sale" v-if="order_sale && order_sale.length">
            <div class="choice_title">选择优惠券</div>
            <div class="reduced" @click="choice_coupon">
              <div class="reduced_title" v-if="!select_sale">
                优惠券
                <span>({{ order_sale.length }})</span>
              </div>
              <div class="select_reduced">
                <div v-if="select_sale">-{{ select_sale.sub_price }}</div>
                <img src="../../assets/images/more_icon.png" />
              </div>
            </div>
          </div>
        </template>
        <div class="manner_foot">
          <button @click="affirm_pay()">确定</button>
        </div>
      </div>
    </div>
    <template v-if="concessions">
      <div class="ttshop_agreement">
        <div class="ttshop_agreementbj" @click="choice_coupon"></div>
        <div class="ttshop_agreementbox">
          <div class="ttshop_agreementitle clearfloat">
            <h5>选择优惠券</h5>
            <div class="close" @click="choice_coupon"></div>
          </div>
          <div class="concess_content">
            <div class="concess_li" v-for="(item, index) in order_sale" :key="index" :data-index="index"
              @click="select_concess">
              <div class="coupon">
                <div class="coupon_left">
                  <div class="coupon_left_price">
                    ￥
                    <div>{{ item.sub_price }}</div>
                  </div>
                </div>
                <div class="title">
                  <div class="title-name">
                    {{ item.event_desc }}
                  </div>
                  <div class="title-condition">满{{ item.min_price }}使用</div>
                  <div class="title-time">
                    有效期至{{ item.begin_time }}-{{ item.end_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
import QRCode from "qrcodejs2";
let Base64 = require("js-base64").Base64;
import "./user.css";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      list: "",
      shopVisible: false,
      payNum: "",
      currTab: -1,
      time: "",
      page_count: 0,
      page: 1,
      finish: false,
      pageShow: true,
      pay_type_list: [],
      payment_type: -1,
      check_pay_type: false, //支付方式
      order_index: -1, //选中的订单
      receipt_detail: "", //查看的订单的详情
      dialogVisible: false,
      filephoto: "",
      presell: false,
      advance_sale: "", //预售的商品内容
      ys_pay_type_list: [],
      // pay_type_list: [],
      payment_type: "",
      user_info: "",
      order_sale: [], //支付尾款时的优惠券
      select_sale: "", //选择的优惠券
      concessions: false, //优惠券的弹窗
      payment_ys_type: -1,
    };
  },
  mounted() {
    if (this.$route.query.tab) {
      this.currTab = this.$route.query.tab;
    }
    console.log(this.currTab, this.$route.query.tab);

    this.getorderList();
  },
  created() {
    let user_info = localStorage.getItem("userInfo");
    if (user_info) {
      this.user_info = user_info;
    }
  },
  methods: {
    goods_detail(goods_id) {
      this.$router.push({
        path: "/pages/goods/goods",
        query: {
          id: goods_id,
        },
      });
    },
    // 上传回执单
    receipt(url, order_id) {
      let that = this;
      this.$api
        .receipt({ order_id: order_id, pay_receipt: url })
        .then((res) => {
          if (res.code == 0) {
            that.getorderList();
          } else {
            that.$message({
              type: "success",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async uploadImg(file, order_id) {
      let that = this;
      const formData = new FormData();
      // console.log(file.raw);
      formData.append("image", this.filephoto.raw);
      let config = {
        headers: {
          "Content-Type": "mutipart/form-data",
        },
      };
      let res = await this.$api.uploadImage(formData, config);
      console.log(res);
      if (res.code == 0) {
        console.log(res.data.url);
        that.$message({
          type: "success",
          message: "上传成功",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        that.receipt(res.data.url, order_id);
      } else {
        this.common.message(this, res);
      }
    },
    handleRemove() {
      this.$refs["receipt_upload"].clearFiles();
    },
    handleChange(file, fileList, order_id) {
      // console.log(file)


      this.filephoto = file;
      this.uploadImg(file, order_id);
      // console.log(file);
      // console.log(fileList);
      // console.log(order_id);
    },
    look_receipt(index) {
      let orderList = this.list;
      this.receipt_detail = orderList[index];
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 选择支付方式
    checkPayType(e) {
      let that = this;
      let index = e.currentTarget.dataset.index;
      that.payment_type = that.pay_type_list[index].payment;
    },
    openPayType(index) {
      this.check_pay_type = true;
      this.order_index = index;
    },
    closePayType() {
      this.check_pay_type = false;
    },
    //切换
    orderTab(index) {
      // if (index > 1) {
      //   this.currTab = index;
      //   this.list = [];
      //   this.finish = true;
      // } else {
      //   if (this.currTab != index) {
      //     this.currTab = index;
      //     this.page = 1;
      //     this.getorderList();
      //   }
      // }
      if (this.currTab != index) {
        this.currTab = index;
        this.page = 1;
        this.getorderList();
      }
    },
    //获取订单列表
    getorderList() {
      let that = this;
      this.finish = false;
      this.$api
        .orderList({
          status: this.currTab,
          limit: 5,
          page: this.page,
        })
        .then((res) => {
          //   console.log(res.data);

          let date = Number(Date.parse(new Date())) / 1000;
          if (res.data.list && res.data.list.length) {
            for (let i in res.data.list) {
              if (res.data.list[i].pre_data) {
                if (res.data.list[i].pre_data.pre_info) {
                  if (
                    Number(
                      res.data.list[i].pre_data.pre_info.deposit_end_time
                    ) > Number(date)
                  ) {
                    res.data.list[i].pre_data.deposit_end = true;
                  } else {
                    res.data.list[i].pre_data.deposit_end = false;
                  }
                  if (
                    Number(res.data.list[i].pre_data.pre_info.final_end_time) >
                    Number(date) &&
                    Number(
                      res.data.list[i].pre_data.pre_info.final_start_time
                    ) < Number(date)
                  ) {
                    res.data.list[i].pre_data.final_end = true;
                  } else {
                    if (
                      Number(
                        res.data.list[i].pre_data.pre_info.final_end_time
                      ) < Number(date)
                    ) {
                      res.data.list[i].pre_data.final_state =
                        "支付尾款时间已结束";
                    } else if (
                      Number(
                        res.data.list[i].pre_data.pre_info.final_start_time
                      ) > Number(date)
                    ) {
                      res.data.list[i].pre_data.final_state =
                        "支付尾款时间还未开始";
                    }
                    res.data.list[i].pre_data.final_end = false;
                  }
                }
              }
            }
          }
          this.list = res.data.list;
          this.page_count = res.data.page_count;
          this.finish = true;
          this.pay_type_list = res.data.pay_type_list;
          that.ys_pay_type_list = res.data.ys_pay_type_list;
          if (
            res.data.pay_type_list[0].payment == 0 ||
            res.data.pay_type_list[0].payment == 1 ||
            res.data.pay_type_list[0].payment == 4
          ) {
            this.payment_type = res.data.pay_type_list[0].payment;
          }
          if (res.data.page_count == 1) {
            this.pageShow = false;
          } else {
            this.pageShow = true;
          }
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    // 支付二维码关闭
    payContTypeChange() {
      let that = this;
      that
        .$confirm("是否取消支付", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.shopVisible = false;
          clearInterval(this.time);
          this.getorderList();
        })
        .catch(() => {
          console.log("取消");
        });
    },
    //订单详情
    goOrderxq(item) {
      console.log(item);
      if (Number(item.refund_type) == 1 || Number(item.refund_type) == 2) {
        this.$router.push({
          path: "/ttshop_barteragree",
          query: {
            id: item.order_refund_id,
          },
        });
      } else {
        this.$router.push({
          path: "/ttshop_orderxq",
          query: {
            id: item.order_id,
          },
        });
      }
    },
    //订单详情
    goEvaluate(id) {
      this.$router.push({
        path: "/ttshop_evaluate",
        query: {
          id: id,
        },
      });
    },
    //退款订单
    turn_order(item) {
      let id = item.order_id;
      let type = item.type;
      if (type == 3) {
        this.$router.push({
          path: "/pages/alibaba/orderRefund/orderRefund",
          query: {
            type: 3,
            order_id: id,
            back_num: 1,
          },
        });
        return false;
      }
      let message = "";
      if (item.pre_data) {
        // 断点
        if (
          item.pre_data.ys_pay_status == 1 ||
          item.pre_data.ys_pay_status == 2
        ) {
          if (
            item.pre_data.pre_info.is_refund == 0 ||
            item.pre_data.pre_info.is_refund == 2
          ) {
            message = "该预售商品不支持退定金";
          }
        }
      }
      this.$confirm("是否退款该订单？" + message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .orderRevoke({
              order_id: id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              this.getorderList();
            })
            .catch((err) => {
              this.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => { });
    },
    //去申请退换货
    goBarter(item) {
      console.log(item);
      let id = item.order_detail_id;
      if (item.type == 3) {
        this.$router.push({
          path: "/pages/alibaba/orderRefund/orderRefund",
          query: {
            type: 1,
            order_detail_id: id,
            order_id: item.order_id,
            back_num: 1,
          },
        });
      } else {
        this.$router.replace({
          path: "/ttshop_barter",
          query: {
            id: item.order_id,
          },
        });
      }
    },
    //取消订单
    orderRevoke(id, index) {
      let list = this.list;
      let message = "";
      if (list[index].pre_data) {
        // 断点
        if (
          list[index].pre_data.ys_pay_status == 1 ||
          list[index].pre_data.ys_pay_status == 2
        ) {
          if (
            list[index].pre_data.pre_info.is_refund == 0 ||
            list[index].pre_data.pre_info.is_refund == 2
          ) {
            message = "该预售商品不支持退定金";
          }
        }
      }
      this.$confirm("确定取消订单？" + message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .orderRevoke({
              order_id: id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              this.getorderList();
            })
            .catch((err) => {
              // console.log(err);
              this.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    //确认收货
    confirm(id) {
      this.$confirm("是否确认已收到货物？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .confirm({
              order_id: id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              this.getorderList();
            })
            .catch((err) => {
              // console.log(err);
              this.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    //支付
    payOrder() {
      let _this = this;
      let id = _this.list[_this.order_index].order_id;
      let payNum = _this.list[_this.order_index].pay_price;
      this.payNum = payNum;
      let params = {
        order_id: id,
      };
      _this.check_pay_type = false;
      if (_this.payment_type == 0 || _this.payment_type == 4) {
        //支付宝
        let payurl = window.location.href;
        let payurls = payurl.split("#")[0] + "#/ttshop_usermyorder";
        // let payurls = "https://test-ttshop-web.oeob.net/#/ttshop_usermyorder";
        params.pay_type = "ALIPAY";
        params.return_url = payurls;
      } else if (_this.payment_type == 1) {
        //微信
        params.pay_type = "WECHAT_PAY";
      } else if (_this.payment_type == 7) {
        // 银联公对公
        let payurl = window.location.href;
        let payurls = payurl.split("#")[0] + "#/ttshop_usermyorder";
        params.pay_type = "NEW_UNION_PAY";
        params.return_url = payurls;
      }
      _this.$api
        .orderPay(params)
        .then((res) => {
          if (_this.payment_type == 0 || _this.payment_type == 4) {
            window.sessionStorage.setItem("alipay_type", true);
            const div = document.createElement("div");
            div.innerHTML = res.data;
            document.body.appendChild(div);
            document.forms[0].submit();
          } else if (_this.payment_type == 1) {
            _this.shopVisible = true;
            _this.time = setInterval(() => {
              _this.orderStatus(res.res.order_no);
            }, 5000);
            let url = Base64.decode(res.res.code_url);
            setTimeout(function () {
              _this.qrcodeScan(url);
            }, 100);
          } else if (_this.payment_type == 7) {
            window.location.href = res.data.url;
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
    qrcodeScan(url) {
      this.$refs.qrcode.innerHTML = "";
      //生成二维码
      let qrcode = new QRCode("qrcode", {
        width: 150, // 二维码宽度
        height: 150, // 二维码高度
        text: url,
      });
    },
    // 预售
    pay_advance(index, order_id) {
      let list = this.list;
      let advance_sale = this.list[index];
      this.advance_sale = advance_sale;
      if (list[index].pre_data) {
        if (list[index].pre_data.ys_pay_status == 1) {
          let balance = 0,
            advance_sale = this.advance_sale;
          balance =
            Number(advance_sale.pre_data.fin_price) +
            Number(advance_sale.express_price);
          advance_sale.balance_cq_price = balance.toFixed(2);
          this.advance_sale = advance_sale;
          this.forwardsale(order_id);
          return false;
        }
      }
      this.presell = true;
    },
    forwardsale(order_id) {
      let that = this;
      this.$api
        .forwardsale({
          order_id: order_id,
        })
        .then((res) => {
          if (res.code == 0) {
            that.order_sale = res.data;
            that.presell = true;
            // console.log(that.advance_sale)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pay_payment() {
      this.presell = false;
      this.advance_sale = "";
      this.select_sale = "";
      this.payment_ys_type = -1;
    },
    choice_coupon() {
      this.concessions = !this.concessions;
      this.presell = !this.presell;
    },
    yscheckPayType(e) {
      console.log("uehiauge");
      let that = this;
      let index = e.currentTarget.dataset.index;
      let data = that.ys_pay_type_list;
      if (data[index].payment == 3) {
        if (
          Number(this.user_info.money) < Number(this.advance_sale.pay_price)
        ) {
          this.$message({
            type: "error",
            message: "余额不足",
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          return false;
        }
      }
      for (let i in data) {
        data[i].checked = false;
      }
      data[index].checked = true;
      let pay_type = {
        pay_type: data[index].pay_type,
        payment: data[index].payment,
      };
      that.payment_ys_type = data[index].payment;
      that.ys_pay_type_list = data;
      that.payment_type = pay_type;
    },

    select_concess(e) {
      let index = e.currentTarget.dataset.index;
      let order_sale = this.order_sale;
      this.select_sale = order_sale[index];
      this.concessions = false;
      this.presell = true;
    },
    affirm_pay() {
      let that = this;
      if (this.payment_type == "") {
        this.$message({
          type: "error",
          message: "请选择支付方式",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      let advance_sale = this.advance_sale;
      if (advance_sale.pre_data) {
        if (advance_sale.pre_data.ys_pay_status == 1) {
          if (this.select_sale) {
            that.affirm_coupon();
          } else {
            that.confirm_pay();
          }
        } else if (advance_sale.pre_data.ys_pay_status == 0) {
          that.confirm_pay();
        }
      }
    },

    // 确认使用优惠券
    affirm_coupon() {
      let that = this;
      let params = {
        order_id: this.advance_sale.order_id,
        user_coupon_id: this.select_sale.user_coupon_id,
      };
      this.$api
        .affirmsale(params)
        .then((res) => {
          if (res.code == 0) {
            that.select_sale = "";
            that.confirm_pay();
          } else {
            that.$message({
              type: "error",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirm_pay() {
      let that = this;

      if (this.payment_type == "") {
        this.$message({
          type: "error",
          message: "请选择支付方式",
          showClose: true,
          offset: 200,
          duration: 1000,
        });
        return false;
      }

      let pay_type = this.payment_type.pay_type;
      let params = {
        pay_type: pay_type,
        order_id: this.advance_sale.order_id,
      };
      this.$api.orderPay(params).then((res) => {
        that.pay_payment();
        if (that.payment_type.payment == 4) {
          window.sessionStorage.setItem("alipay_type", true);
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
        } else if (that.payment_type.payment == 1) {
          that.shopVisible = true;
          that.time = setInterval(() => {
            that.orderStatus(res.res.order_no);
          }, 5000);
          let url = Base64.decode(res.res.code_url);
          setTimeout(function () {
            that.qrcodeScan(url);
          }, 100);
        } else {
          that.$message({
            showClose: true,
            message: "购买成功",
            type: "success",
            offset: 200,
            duration: 1000,
          });
          // that.orderStatus(res.res.order_no);
          that.page = 1;
          that.getorderList();
        }
      });
    },
    // end
    //订单状态
    orderStatus(order) {
      if (this.shopVisible == false) {
        clearInterval(this.time);
        console.log("123");
      }
      this.$api
        .orderStatus({
          order_no: "order_" + order,
        })
        .then((res) => {
          if (res.code == 0) {
            clearInterval(this.time);
            this.$message({
              type: "success",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
            this.shopVisible = false;
            this.getorderList();
            // this.$router.push("/ttshop_mybalance");
          }
        })
        .catch((err) => { });
    },
    //上一页
    pages_perv() {
      this.page--;
    },
    // 下一页
    page_next() {
      this.page++;
    },
    // 输入分页
    handleCurrentChange(e) {
      this.page = e;
      this.common.backTop();
      this.getorderList();
    },
    //撤回申请
    withdraw(id) {
      this.$confirm("是否撤回申请？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .revokeRefund({
              order_type: "SHOP",
              order_refund_id: id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              this.getorderList();
            })
            .catch((err) => {
              // console.log(err);
              this.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-item {
  position: relative;
  width: 80%;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #ebebeb;
  cursor: pointer;
  padding: 7px;
  box-sizing: border-box;
  margin: 0 auto 20px;

  &.active {
    border-color: #ff0e25;
  }

  .pay-img {
    float: left;
    width: 28px;
    height: 28px;
    border-radius: 2px;
    overflow: hidden;
  }

  .pay-name {
    float: left;
    padding-left: 12px;
    font-size: 14px;
    color: #333;
    line-height: 28px;
  }

  .pay-select {
    width: 12px;
    height: 12px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

// 支付方式
.ttshop_agreement {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .ttshop_agreementbj {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .ttshop_agreementbox {
    width: 400px;
    // height: 260px;
    background: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -200px;
    margin-top: -130px;
    border: 4px solid rgba(0, 0, 0, 0.4);
    border-radius: 4px;

    .ttshop_agreementitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding: 0 15px;
      box-sizing: border-box;

      h5 {
        float: left;
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }

      .close {
        cursor: pointer;
        float: right;
        display: block;
        width: 20px;
        height: 20px;
        background: url(../../assets/images/ttshop_colse.png) center no-repeat;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        outline: none;
        margin-top: 10px;

        &:hover {
          background: url(../../assets/images/ttshop_colsed.png) center no-repeat;
        }
      }
    }

    .ttshop_agreementext {
      width: 100%;
      padding: 20px 20px 10px 20px;
      box-sizing: border-box;

      p {
        font-size: 14px;
        color: #333;
        text-indent: 2em;
        line-height: 26px;
      }
    }

    .ttshop_agreementbut {
      width: 100%;
      height: 60px;
      // position: absolute;
      // bottom: 0;
      // left: 0;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        display: block;
        width: 180px;
        height: 40px;
        font-size: 14px;
        color: #fff;
        border-radius: 2px;
        outline: none;
        // margin: 10px auto 0;
        margin: 0 auto;
        border: 0;
        cursor: pointer;
        background: #ff0e25;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        &:hover {
          box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
        }
      }
    }
  }
}

.orderlist {
  width: 100%;
  box-sizing: border-box;

  .listitem {
    float: left;
    // width: 76%;
    width: 48%;
  }
}

.ttshop_userights {
  padding: 16px 24px;
  box-sizing: border-box;
  background: #fff;

  .ttshop_myorder {
    width: 100%;
    margin-bottom: 16px;

    ul {
      float: left;

      li {
        float: left;
        font-size: 12px;
        color: #333;
        font-weight: 400;
        line-height: 12px;
        padding: 8px 0;
        box-sizing: border-box;
        margin-right: 24px;
        cursor: pointer;
        position: relative;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        &::before {
          content: "";
          width: 0%;
          height: 2px;
          background: #ff0e25;
          position: absolute;
          bottom: -2px;
          left: 50%;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
          transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          -o-transform: translateX(-50%);
        }

        &:hover {
          color: #ff0e25;
        }

        &:hover::before {
          width: 100%;
        }

        &.active {
          font-weight: 600;
          color: #ff0e25;
        }

        &.active:before {
          width: 100%;
        }
      }

      & li:last-child {
        margin-right: 0;
      }
    }

    .ttshop_myorderseach {
      float: right;
      position: relative;

      input {
        width: 211px;
        height: 28px;
        border: 1px solid #ebebeb;
        font-size: 12px;
        color: #333;
        padding: 0 70px 0 8px;
        box-sizing: border-box;
        outline: none;
        border-radius: 2px;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        &:focus {
          border-color: #ff0e25;
        }
      }

      button {
        width: 62px;
        height: 26px;
        display: block;
        font-size: 12px;
        color: #333;
        text-align: center;
        position: absolute;
        top: 1px;
        right: 1px;
        border: 0;
        outline: none;
        background: #ebebeb;
        cursor: pointer;
        border-radius: 0 2px 2px 0;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        &:hover {
          background: #ff0e25;
          color: #fff;
        }
      }
    }
  }

  .ttshop_myorderzw {
    width: 100%;
    min-height: 600px;
    background: #fff;
    padding-top: 180px;
    box-sizing: border-box;

    // display: none;
    img {
      display: block;
      width: 93px;
      height: 80px;
      margin: 0 auto 20px;
    }

    p {
      font-size: 14px;
      color: #333;
      text-align: center;
    }
  }

  .ttshop_myorderlist {
    width: 100%;

    .ttshop_myordertitle {
      width: 100%;
      background: #f5f5f5;
      height: 32px;
      margin-bottom: 20px;

      .ttshop_myordertext {
        float: left;
        // width: 50%;
        width: 78%;
        padding-top: 8px;
        padding-left: 20px;
        box-sizing: border-box;

        .ttshop_myordertexter {
          display: table;
          // cursor: pointer;
          position: relative;

          p {
            float: left;
            font-size: 12px;
            color: #333;
          }

          i {
            float: left;
            width: 12px;
            height: 12px;
            margin-top: 2px;

            img {
              display: block;
              width: 100%;
            }
          }
        }
      }

      .ttshop_myorderdj {
        float: left;
        width: 11%;
        padding-top: 8px;
        box-sizing: border-box;

        p {
          font-size: 12px;
          color: #333;
          text-align: center;
        }
      }

      .ttshop_myorderdjs {
        float: left;
        width: 12%;
        padding-top: 8px;
        box-sizing: border-box;

        p {
          font-size: 12px;
          color: #333;
          text-align: center;
        }
      }

      .ttshop_myorderzfje {
        float: left;
        width: 16%;
        padding-top: 8px;
        box-sizing: border-box;

        p {
          font-size: 12px;
          color: #333;
          text-align: center;
        }
      }

      // .ttshop_myorderzt {
      //   float: left;
      //   width: 14%;
      //   padding-top: 8px;
      //   box-sizing: border-box;
      //   .ttshop_myorderzts {
      //     // cursor: pointer;
      //     p {
      //       float: left;
      //       font-size: 12px;
      //       color: #333;
      //     }
      //     i {
      //       float: left;
      //       width: 12px;
      //       height: 12px;
      //       margin-top: 2px;
      //       img {
      //         display: block;
      //         width: 100%;
      //       }
      //     }
      //   }
      // }
      .ttshop_myordercz {
        float: left;
        width: 24%;
        padding-top: 8px;
        box-sizing: border-box;

        p {
          font-size: 12px;
          color: #333;
          text-align: center;
        }
      }
    }

    .ttshop_myordercon {
      width: 100%;

      .ttshop_myorderconed {
        width: 100%;
        margin-bottom: 20px;

        .ttshop_myordercontitle {
          width: 100%;
          height: 32px;
          background: #f5f5f5;
          padding: 0 20px;
          box-sizing: border-box;
          line-height: 32px;

          p {
            float: left;
            font-size: 12px;
            color: #999;
            margin-right: 24px;

            span {
              font-size: 12px;
              color: #999;
            }

            strong {
              color: #333;
              font-weight: 500;
            }
          }

          & p:last-child {
            margin-right: 0;
            // float: right;
          }

          .ttshop_myordercontitle_right {
            float: right;
            line-height: 32px;

            .ttshop_cancel {
              font-size: 12px;
              color: #999;
              // margin-bottom: 2px;
            }

            .ttshop_over {
              font-size: 12px;
              color: #ff0e25;
              // margin-bottom: 2px;
            }

            strong {
              font-size: 12px;
              color: #ff0e25;
              font-weight: 400;
              cursor: pointer;
            }
          }
        }

        .ttshop_myorderconlist {
          width: 100%;
          min-height: 112px;
          border-left: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;
          box-sizing: border-box;
          border-right: 0;
          border-top: 0;

          .ttshop_myorderconleft {
            float: left;
            // width: 50%;
            width: 78%;
            min-height: 112px;
            padding: 16px 20px 16px 10px;
            box-sizing: border-box;

            .ttshop_orderimg {
              float: left;
              width: 80px;
              height: 80px;
              margin-right: 12px;

              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .ttshop_orderimg:hover {
              cursor: pointer;
            }

            .ttshop_ordertext {
              float: left;
              width: 205px;

              h5 {
                font-size: 12px;
                color: #333333;
                font-weight: 500;
                line-height: 18px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-bottom: 8px;
              }

              span {
                font-size: 12px;
                color: #999;
                margin-right: 5px;

                strong {
                  font-weight: 400;
                  font-size: 12px;
                  color: #999;
                }
              }
            }

            .ttshop_ordertext:hover {
              cursor: pointer;
            }
          }

          .ttshop_myorderdj {
            float: left;
            width: 11%;
            text-align: center;
            padding-top: 16px;
            min-height: 112px;
            box-sizing: border-box;

            p {
              font-size: 12px;
              color: #333;

              span {
                font-size: 12px;
                color: #333;
              }
            }
          }

          .ttshop_myorderdjer {
            border-right: 1px solid #ebebeb;
          }




          // .ttshop_qbzt {
          //   float: left;
          //   width: 15%;
          //   text-align: center;
          //   padding-top: 16px;
          //   min-height: 138px;
          //   box-sizing: border-box;
          //   border-right: 1px solid #ebebeb;
          //   .ttshop_wfk {
          //     font-size: 12px;
          //     color: #ff8500;
          //     margin-bottom: 2px;
          //   }
          //   .ttshop_cancel {
          //     font-size: 12px;
          //     color: #999;
          //     margin-bottom: 2px;
          //   }
          //   .ttshop_over {
          //     font-size: 12px;
          //     color: #333;
          //     margin-bottom: 2px;
          //   }
          //   strong {
          //     font-size: 12px;
          //     color: #ff0e25;
          //     font-weight: 400;
          //     cursor: pointer;
          //   }
          // }

          .ttshop_caozuo {
            float: left;
            width: 16%;
            text-align: center;
            padding-top: 16px;
            min-height: 112px;
            box-sizing: border-box;
            border-right: 1px solid #ebebeb;

            .ttshop_ljzf {
              display: block;
              width: 72px;
              height: 24px;
              border: 1px solid #ff3346;
              background: #fff0f1;
              line-height: 24px;
              text-align: center;
              font-size: 12px;
              color: #ff0e25;
              margin: 0 auto 8px;
              border-radius: 2px;
              cursor: pointer;
            }

            .ttshop_cztext {
              font-size: 12px;
              color: #333;
              margin-bottom: 8px;
              cursor: pointer;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover {
                color: #ff0e25;
              }
            }

            .ttshop_hg {
              display: block;
              width: 72px;
              height: 24px;
              background: #ebebeb;
              line-height: 24px;
              text-align: center;
              font-size: 12px;
              color: #999;
              margin: 0 auto 8px;
              border-radius: 2px;
              cursor: pointer;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover {
                background: #ff0e25;
                color: #fff;
              }
            }

            .ttshop_queren {
              display: block;
              width: 72px;
              height: 24px;
              background: #ff0e25;
              line-height: 24px;
              text-align: center;
              font-size: 12px;
              color: #fff;
              margin: 0 auto 8px;
              border-radius: 2px;
              cursor: pointer;
            }
          }
        }
      }

      .ttshop_shr {
        float: left;
        width: 12%;
        text-align: center;
        padding-top: 16px;
        min-height: 112px;
        box-sizing: border-box;
        border-right: 1px solid #ebebeb;
        border-bottom: solid 1px #ebebeb;
        position: relative;

        p {
          font-size: 12px;
          color: #333;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .ttshop_zfzje {
        float: left;
        width: 16%;
        text-align: center;
        padding-top: 16px;
        min-height: 112px;
        box-sizing: border-box;
        border-right: 1px solid #ebebeb;
        font-weight: bold;
        border-bottom: solid 1px #ebebeb;
        position: relative;

        p {
          font-size: 12px;
          color: #333;
          // margin-bottom: 8px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          span {
            font-size: 12px;
            color: #333;
          }
        }

        strong {
          font-size: 12px;
          color: #333;
          font-weight: 400;
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }
      }

      .ttshop_caozuos {
        float: right;
        width: 24%;
        text-align: center;
        padding-top: 16px;
        min-height: 112px;
        box-sizing: border-box;
        border-right: 1px solid #ebebeb;
        border-bottom: 1px solid #ebebeb;

        .ttshop_cztexts {
          font-size: 12px;
          color: #ff0e25;
          margin-bottom: 8px;
        }

        .ttshop_ljzf {
          display: block;
          width: 72px;
          height: 24px;
          border: 1px solid #ff3346;
          background: #fff0f1;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #ff0e25;
          margin: 0 auto 8px;
          border-radius: 2px;
          cursor: pointer;
        }

        .ttshop_cztext {
          font-size: 12px;
          color: #333;
          margin-bottom: 8px;
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }

        .ttshop_hg {
          display: block;
          width: 72px;
          height: 24px;
          background: #ebebeb;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #999;
          margin: 0 auto 8px;
          border-radius: 2px;
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            background: #ff0e25;
            color: #fff;
          }
        }

        .ttshop_queren {
          display: block;
          width: 72px;
          height: 24px;
          background: #ff0e25;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          margin: 0 auto 8px;
          border-radius: 2px;
          cursor: pointer;
        }
      }
    }

    .ttshop_myorderpage {
      width: 100%;
      margin-top: 32px;

      .ttshop_pages {
        float: right;
      }
    }
  }
}

.ttshop_pay {
  .pay-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pay-qrcode {
    width: 200px;
    height: 200px;
  }
}

.monad_bill {
  display: flex;
  align-items: center;

  .monad_chong {
    margin-right: 10px !important;
  }
}

.bill_monad {
  width: 100%;
  height: auto;

  img {
    width: 100%;
    height: auto;
  }
}

//预售的支付方式
.payment_head {
  padding: 20px 20px 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .payment_head_title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  }

  .payment_head_price {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;

    p {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }
}

.payment_manner {
  width: 100%;
  padding: 10px 20px 10px 20px;
  box-sizing: border-box;

  .manner_list {
    position: relative;
    width: 80%;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #ebebeb;
    cursor: pointer;
    padding: 7px;
    box-sizing: border-box;
    margin: 0 auto 10px;

    &.active {
      border-color: #ff0e25;
    }

    .pay-img {
      float: left;
      width: 28px;
      height: 28px;
      border-radius: 2px;
      overflow: hidden;
    }

    .pay-name {
      float: left;
      padding-left: 12px;
      font-size: 14px;
      color: #333;
      line-height: 28px;
    }

    .pay-select {
      width: 12px;
      height: 12px;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}

.manner_foot {
  width: 100%;
  height: 60px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    display: block;
    width: 180px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    border-radius: 2px;
    outline: none;
    margin: 0 auto;
    border: 0;
    cursor: pointer;
    background: #ff0e25;
    transition: 0.5s;
    -moz-transition: 0.5s;
    -webkit-transition: 0.5s;
    -o-transition: 0.5s;

    &:hover {
      box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
    }
  }
}

.choice_sale {
  // margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}

.choice_title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}

.reduced {
  // margin-top: 8px;
  // padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reduced_title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.reduced_title span {
  margin-left: 5px;
}

.select_reduced {
  display: flex;
  align-items: center;
}

.select_reduced div {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  margin-right: 8px;
}

.select_reduced img {
  width: 14px;
  height: 14px;
}

.concess_content {
  margin-top: 22px;
  max-height: 443px;
  overflow-y: scroll;

  .concess_li {
    margin: 10px 20px;
    height: 87px;
    background-image: url("../../assets/images/youhui.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .coupon {
      width: 100%;
      height: 87px;
      display: flex;
      align-items: center;

      .coupon_left {
        width: 94px;
        height: 87px;
        display: flex;
        justify-content: center;
        align-items: center;

        .coupon_left_price {
          display: flex;
          align-items: flex-end;
          font-size: 14px;
          font-family: Lato-Bold, Lato;
          font-weight: bold;
          color: #ff3000;
          line-height: 14px;

          div {
            font-size: 25px;
            font-family: Lato-Bold, Lato;
            font-weight: bold;
            color: #ff3000;
            line-height: 25px;
          }
        }
      }

      .title {
        margin-left: 16px;
        color: #ff0e25;

        .title-name {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ff0e25;
          line-height: 14px;
        }

        .title-time {
          margin-top: 12px;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff0e25;
        }

        .title-condition {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff3000;
          line-height: 12px;
          margin-top: 6px;
        }
      }
    }
  }
}
</style>
